const transform = require('./lib/jsonMapTransform');

module.exports = transform;